<template>
  <div>
    <p
      v-show="isShow && bankName"
      class="bottom-info"
      :class="isRelative ? 'relative' : ''"
    >该信息由{{bankName}}提供</p>
  </div>
</template>

<script>
export default {
  name: 'ServerBank',
  props: {
    productId: {
      type: String,
      default: '',
    },
    isRelative: { // 默认绝对定位，可控制文字相对定位
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bankName: '',
      isShow: true,
    };
  },
  mounted() {
    this.getBankNameByProduct();

    // 安卓系统absolute元素兼容
    if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
      const IH = window.innerHeight;
      window.addEventListener('resize', () => {
        if (window.innerHeight < IH) {
          this.isShow = false;
        } else {
          this.isShow = true;
        }
      });
    }
  },
  methods: {
    // 获取该产品所属服务银行名称
    getBankNameByProduct() {
      this.$api.PublicPage.getBankNameByProduct({
        productId: this.productId,
      }).then((res) => {
        this.bankName = res.data.isShowOrgDoc ? res.data.showOrgName : '';
      });
    },
  },
};
</script>
<style scoped>
.bottom-info {
  width: 100%;
  position: absolute;
  bottom: 16px;
  font-size: 13px;
  color: #b3b5b7;
  text-align: center;
  pointer-events: none;
}
.relative {
  position: relative;
  top: 16px;
  padding-bottom: 16px;
}
p {
  margin: 0;
}
</style>
